import React, { useState, Fragment, Component } from 'react';
import { Bot, Copy, Check } from 'lucide-react';
import type { Message } from '../../hooks/useChat';
import { BudgetBreakdown, GoalProgressCards, InvestmentSummaryCard, TransactionMiniList, InsightCard } from './rich';
interface ChatMessageProps {
  message: Message;
}
function renderMarkdown(text: string): React.ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i} className="font-semibold" data-id="element-21">
          {part.slice(2, -2)}
        </strong>;
    }
    // Handle newlines
    return part.split('\n').map((line, j) => <Fragment key={`${i}-${j}`} data-id="element-22">
        {j > 0 && <br data-id="element-23" />}
        {line}
      </Fragment>);
  });
}
export function ChatMessage({
  message
}: ChatMessageProps) {
  const [copied, setCopied] = useState(false);
  const isUser = message.role === 'user';
  const handleCopy = () => {
    navigator.clipboard.writeText(message.content);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  if (isUser) {
    return <div className="flex justify-end mb-4" data-id="element-24">
        <div className="max-w-[80%]" data-id="element-25">
          <div className="bg-primary-500 text-white rounded-2xl rounded-tr-sm px-4 py-2.5 text-sm leading-relaxed" data-id="element-26">
            {message.content}
          </div>
          <p className="text-xs text-gray-400 mt-1 text-right" data-id="element-27">
            {message.timestamp.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          })}
          </p>
        </div>
      </div>;
  }
  return <div className="flex gap-2.5 mb-4 group" data-id="element-28">
      <div className="w-7 h-7 rounded-full bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center shrink-0 mt-0.5" data-id="element-29">
        <Bot size={14} className="text-white" data-id="element-30" />
      </div>
      <div className="flex-1 min-w-0" data-id="element-31">
        <div className="bg-white dark:bg-dark-card border border-gray-100 dark:border-dark-border rounded-2xl rounded-tl-sm px-4 py-3 text-sm text-gray-800 dark:text-gray-200 leading-relaxed shadow-sm" data-id="element-32">
          <span className={message.isStreaming ? 'streaming-cursor' : ''} data-id="element-33">
            {renderMarkdown(message.content)}
          </span>

          {/* Rich components */}
          {!message.isStreaming && message.richData && <>
              {message.richData.type === 'budget_breakdown' && <BudgetBreakdown categories={message.richData.payload.categories} data-id="element-34" />}
              {message.richData.type === 'goal_progress' && <GoalProgressCards goals={message.richData.payload.goals} data-id="element-35" />}
              {message.richData.type === 'investment_summary' && <InvestmentSummaryCard investments={message.richData.payload.investments} data-id="element-36" />}
              {message.richData.type === 'transaction_list' && <TransactionMiniList transactions={message.richData.payload.transactions} data-id="element-37" />}
              {message.richData.type === 'insight_card' && <InsightCard payload={message.richData.payload} data-id="element-38" />}
            </>}
        </div>

        <div className="flex items-center gap-2 mt-1" data-id="element-39">
          <p className="text-xs text-gray-400" data-id="element-40">
            {message.timestamp.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          })}
          </p>
          {!message.isStreaming && <button onClick={handleCopy} className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-gray-100 dark:hover:bg-dark-hover" data-id="element-41">
              {copied ? <Check size={12} className="text-accent-500" data-id="element-42" /> : <Copy size={12} className="text-gray-400" data-id="element-43" />}
            </button>}
        </div>
      </div>
    </div>;
}